import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const desktopClasses = {
  servicesSubMenu: css`
    padding-inline-end: ${spacing(4)}; // 32px
  `,
  menus: css`
    display: none;
  `,
  visible: css`
    display: block;
  `,
  titles: css`
    max-inline-size: max-content;
    padding-inline-end: ${spacing(4)};
  `,
}
